import React from 'react';
import {useDispatch} from "react-redux";

// components
import {Button} from "@material-ui/core";

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import { setSearchType, setSearchPreset } from '~/slices/items/itemSearchOption'

// resources
import { presetDiseases } from '~/data/shop/itemSearchPreset'

export const Diseases = (props) => {
  const { searchType } = props
  const dispatch = useDispatch()

  const searchPreset = (value) => {
    dispatch(setSearchType(searchType))
    dispatch(setSearchPreset(value))
    dispatch(toggleDrawer({openFlg: false, key: 'search'}))

    // const pathname = '/items/'
    // router.push(pathname)
  }

  return (
      <div>
        <ul>
          {
            presetDiseases.list.map((item, index) => (
                <li key={index}>
                  <Button onClick={() => searchPreset({diseases: item.code})}>
                    {
                      item.label
                    }
                  </Button>
                </li>
            ))
          }
        </ul>
      </div>
  );
};
